import { isEmptySlateDocument } from "../../../core/constants";
import {
  Configuration,
  DisplayMode,
  ImageAndTextDetails,
  Section,
} from "../../../resources/modelTypes";
import { DisplayPhotoOrVideo } from "../DisplayPhotoOrVideo";
import { ThemedRichText } from "./ThemedRichText";
import { css } from "@emotion/react";
import { SmallHeadline } from "@minted/fancyclothes";
import { theme } from "@minted/minted-components";
import React, { memo } from "react";

const styles = {
  alignment: (isHorizontal: boolean) => css`
    ${
      isHorizontal &&
      css`
        display: flex;
        justify-content: center;
      `
    }
  `,
  horizontalPhoto: css`
    width: 40%;
  `,
  textContainer: (displayMode: DisplayMode) => css`
    display: flex;
    flex-direction: column;

    ${
      (displayMode === DisplayMode.Left || displayMode === DisplayMode.Right) &&
      css`
        margin-left: ${theme.spacing.x2};
        margin-right: ${theme.spacing.x2};
        width: 40%;
      `
    }

    ${
      displayMode === DisplayMode.Top &&
      css`
        margin-bottom: ${theme.spacing.x4};
      `
    }
    ${
      displayMode === DisplayMode.Bottom &&
      css`
        margin-top: ${theme.spacing.x4};
      `
    }
  `,
};

export type DisplayImageAndTextSectionProps = {
  configuration: Configuration;
  section: Section;
};

const DisplayImageAndTextSection = ({
  configuration,
  section,
}: DisplayImageAndTextSectionProps) => {
  const details = section.sectionDetails as ImageAndTextDetails;
  const isHorizontal =
    details.displayMode === DisplayMode.Left ||
    details.displayMode === DisplayMode.Right;

  const textContent = (
    <div css={styles.textContainer(details.displayMode)}>
      {Boolean(details.title) && <SmallHeadline>{details.title}</SmallHeadline>}
      {!isEmptySlateDocument(details.content) && (
        <ThemedRichText content={details.content} />
      )}
    </div>
  );

  return (
    <>
      <div css={styles.alignment(isHorizontal)}>
        {(details.displayMode === DisplayMode.Right ||
          details.displayMode === DisplayMode.Bottom) &&
          textContent}
        {(section.photo || section.image || section.video) && (
          <div css={isHorizontal && styles.horizontalPhoto}>
            <DisplayPhotoOrVideo
              configuration={configuration}
              section={section}
            />
          </div>
        )}
        {(details.displayMode === DisplayMode.Left ||
          details.displayMode === DisplayMode.Top) &&
          textContent}
      </div>
    </>
  );
};

const MemoizedDisplayImageAndTextSection = memo(DisplayImageAndTextSection);

export { MemoizedDisplayImageAndTextSection as DisplayImageAndTextSection };
